import React, { Suspense, useCallback, useContext, useEffect, useState } from 'react'
import { NavLink, useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { getReport, getReportCategories } from './Service/ReportService';
import ERROR_LIST from '../../../Services/Global-Services/Hadle_Errors';
import ComponentLoader from '../../../Shared/Sidebar/ComponentLoader';
import { TostMsg } from '../../../App';

function Reports() {
	const [reportCategoriesList, setReportCategoriesList] = useState([])
	const [reportList, setReportList] = useState([])
	const [activeTab, setActiveTab] = useState(0);
	let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
	let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
	const [Isloading, setIsloading] = useState(false);
	const history = useHistory();
	const toster = useContext(TostMsg);
	const [searchText, setSearchText] = useState("");
	const [reportHeadingData, setReportHeadingData] = useState();
	const [reportSubHeadingData, setReportSubHeadingData] = useState();
	const filteredReports = reportList.filter((item) => {
		const search = searchText.toLowerCase();
		return (
			item?.ReportName?.toLowerCase().includes(search) ||
			item?.ReportDescription?.toLowerCase().includes(search) ||
			item?.ReportCategoryName?.toLowerCase().includes(search)
		);
	});

	useEffect(() => {
		getReportCategoriesList();
		GetMasterSystemAlertList("Report_Heading", 1)
		GetMasterSystemAlertList("Report_SubHeading", 2)
		getReportList(0);
	}, []);


	const GetMasterSystemAlertList = useCallback(async (message, type) => {
		SystemAlerts?.filter((msg) => {
			if (msg?.Name == message && type == 0) {
				toster.current.success(msg?.Desc);
			} else if (msg?.Name == message && type == 1) {
				setReportHeadingData(msg?.Desc);
			} else if (msg?.Name == message && type == 2) {
				setReportSubHeadingData(msg?.Desc);
			}
		});
	}, []);



	async function getReportCategoriesList() {
		setIsloading(true);
		var params = { empID: 0 };
		try {
			let reportCategoriesList = await getReportCategories(params);
			if (reportCategoriesList?.Data) {
				const allCategory = {
					Id: 0,
					GUID: "all",
					ReportCategoryName: "All",
					ReportCategoryDescription: "All Reports",
					ReportCategoryIcon: "/images/org-img/reports/all.png"

				};
				const finalList = [allCategory, ...reportCategoriesList.Data];
				setReportCategoriesList(finalList);
			}
			setIsloading(false);
		} catch (error) {
			toster.current.error(ERROR_LIST.DefaultError);
			setIsloading(false);
		}
	}


	const handleCategoryClick = (categoryId) => {
		setActiveTab(categoryId);
		getReportList(categoryId);
	};


	async function getReportList(activeTab) {
		setIsloading(true);
		var params = { CategoryId: activeTab };
		try {
			let response = await getReport(params);
			if (response?.Data) {
				let filteredData =
					activeTab === 0
						? response.Data
						: response.Data.filter(
							(item) => item.ReportCategoryId === activeTab
						);
				setReportList(filteredData);
			}
			setIsloading(false);
		} catch (error) {
			toster.current.error(ERROR_LIST.DefaultError);
			setIsloading(false);
		}
	}

	const handleNavigation = (id) => {
		switch (id) {
			case 101:
				history.push("/Report/Request/OpenSummary");
				break;

			case 103:
				history.push("/Report/Profile/MissingAttributes");
				break;

			case 105:
				history.push("/Report/DayOff/LeaveAndWFHBalance");
				break;

			case 106:
				history.push("/Report/DayOff/LeaveSummary");
				break;

			case 104:
				history.push("/Report/DayOff/WFHSummary");
				break;

			default:
				history.push("/Report/Request/ClosedSummary");
		}
	};

	return (
		<div>
			<div className="container-fluid">
				<div className="row justify-content-center">
					<div className="onboarding-screen">
						<div className="row justify-content-center">
							<div className="col-xl-10">
								<div className="mt-0">
									<div className='top-reportdiv'>
										<img src='/images/org-img/reports/1.png' />
										<div className='content'>
											<h2>{reportHeadingData}</h2>
											<p>{reportSubHeadingData}</p>
											<div className='report-search'>
												<input type='text' value={searchText}
													onChange={(e) => setSearchText(e.target.value)} className='form-control' placeholder='Search by name or category' />
												{/* <button>Search</button> */}
											</div>
										</div>
									</div>
									<div className="reports-setting mt-4 reports-block-bx">
										<div className="nav flex-column nav-pills" id="v-pills-tab"
											role="tablist" aria-orientation="vertical">
											{reportCategoriesList.map((item) => (
												<>

													<button
														key={item.Id}
														className={`nav-link ${activeTab === item.Id ? "active" : ""}`}
														onClick={() => handleCategoryClick(item.Id)}
														type="button"
													>
														{item.ReportCategoryName && (<span>	<img style={{ width: "13px" }} src={item?.ReportCategoryIcon} /></span>)}		{item.ReportCategoryName}
													</button>
												</>
											))}
										</div>
										{/* <div className="nav flex-column nav-pills" id="v-pills-tab"
											role="tablist" aria-orientation="vertical">
											<button className="nav-link active" id="v-pills-home-tab"
												data-bs-toggle="pill" data-bs-target="#v-pills-home"
												type="button" role="tab" aria-controls="v-pills-home"
												aria-selected="true">All</button>
											<button className="nav-link" id="v-pills-messages-tab"
												data-bs-toggle="pill" data-bs-target="#v-pills-messages"
												type="button" role="tab" aria-controls="v-pills-messages"
												aria-selected="false">Leave report</button>
											<button className="nav-link" id="v-pills-profile-tab"
												data-bs-toggle="pill" data-bs-target="#v-pills-profile"
												type="button" role="tab" aria-controls="v-pills-profile"
												aria-selected="false">PMS report</button>
											<button className="nav-link" id="v-pills-settings-tab"
												data-bs-toggle="pill" data-bs-target="#v-pills-settings"
												type="button" role="tab" aria-controls="v-pills-settings"
												aria-selected="false">Tickets Report</button>
											<button className="nav-link" id="v-pills-settings-tab"
												data-bs-toggle="pill" data-bs-target="#v-pills-settings"
												type="button" role="tab" aria-controls="v-pills-settings"
												aria-selected="false">Work From home Report</button>
											<button className="nav-link" id="v-pills-settings-tab"
												data-bs-toggle="pill" data-bs-target="#v-pills-settings"
												type="button" role="tab" aria-controls="v-pills-settings"
												aria-selected="false">Employee Report</button>
											<button className="nav-link" id="v-pills-settings-tab"
												data-bs-toggle="pill" data-bs-target="#v-pills-settings"
												type="button" role="tab" aria-controls="v-pills-settings"
												aria-selected="false">Report 8</button>

										</div> */}
										<div className="tab-content" id="v-pills-tabContent"
											style={{ width: "calc(100% - 140px);" }}>
											<div id="v-pills-home"
												className={`tab-pane fade ${true ? "show active" : ""}`}
												role="tabpanel" aria-labelledby="v-pills-home-tab">
												<div className="setting-detail-list">
													<div className="title-text"><h3> {activeTab === 0
														? `All Reports (${reportList.length})`
														: `${reportCategoriesList.find((x) => x.Id === activeTab)?.ReportCategoryName} Report (${reportList.length})`
													}</h3></div>
													<div className="detail">
														<div className="columns is-multiline">
															{filteredReports.length > 0 ? (
																filteredReports.map((item) => (
																	<div className="column is-4" key={item.Id}>
																		<div
																			className="tile-grid-item"
																			onClick={() => handleNavigation(item?.Id)}
																		>
																			<div className="tile-grid-item-inner">
																				<img
																					src={item.ReportIcon}
																					data-demo-src="assets/img/icons/files/pdf.svg"
																					alt=""
																				/>
																				<div className="meta">
																					<span className="dark-inverted">{item.ReportName}</span>
																					<span>{item.ReportDescription}</span>
																				</div>
																			</div>
																		</div>
																	</div>
																))
															) : (
																<div style={{ padding: "20px" }}>
																	No Reports Available
																</div>
															)}


														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>{Isloading ? (
				<Suspense>
					<ComponentLoader />
				</Suspense>
			) : ("")}
		</div>
	)
}

export default Reports